import React from 'react';
import styles from "../../../../styles/office/EditModal.module.css";

// Remark Alert Dialog
export const RemarkAlertDialog = ({
  language,
  onCancel,
  onConfirm
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.confirmationDialog}>
      <h3>{language === 'en' ? 'Remark is not entered' : 'टिप्पणी प्रविष्ट केलेली नाही'}</h3>
      <p>{language === 'en'
        ? 'Please enter a remark'
        : 'कृपया टिप्पणी प्रविष्ट करा'}</p>
      <div className={styles.confirmationButtons}>
        <button
          onClick={onCancel}
          className={styles.cancelButton}
        >
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button
          onClick={onConfirm}
          className={styles.saveButton}
        >
          {language === 'en' ? 'Ok' : 'पुष्टी करा'}
        </button>
      </div>
    </div>
  </div>
);

// Zone Alert Dialog
export const ZoneAlertDialog = ({
  language,
  onCancel,
  onConfirm
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.confirmationDialog}>
      <h3>{language === 'en' ? 'Zone Statement is not entered' : 'टिप्पणी प्रविष्ट केलेली नाही'}</h3>
      <p>{language === 'en'
        ? 'Please enter a remark'
        : 'कृपया टिप्पणी प्रविष्ट करा'}</p>
      <div className={styles.confirmationButtons}>
        <button
          onClick={onCancel}
          className={styles.cancelButton}
        >
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button
          onClick={onConfirm}
          className={styles.saveButton}
        >
          {language === 'en' ? 'Ok' : 'पुष्टी करा'}
        </button>
      </div>
    </div>
  </div>
);

// Upload Alert Dialog
export const UploadAlertDialog = ({
  language,
  onCancel,
  onConfirm
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.confirmationDialog}>
      <h3>{language === 'en' ? 'Document is not uploaded' : 'दस्तऐवज अपलोड केलेला नाही'}</h3>
      <p>{language === 'en'
        ? 'Please upload the document'
        : 'कृपया दस्तऐवज अपलोड करा'}</p>
      <div className={styles.confirmationButtons}>
        <button
          onClick={onCancel}
          className={styles.cancelButton}
        >
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button
          onClick={onConfirm}
          className={styles.saveButton}
        >
          {language === 'en' ? 'Ok' : 'पुष्टी करा'}
        </button>
      </div>
    </div>
  </div>
);

// Payment Alert Dialog
export const PaymentAlertDialog = ({
  language,
  onCancel,
  onConfirm
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.confirmationDialog}>
      <h3>{language === 'en' ? 'Payment Details Required' : 'पेमेंट तपशील आवश्यक आहेत'}</h3>
      <p>{language === 'en'
        ? 'Please fill all payment details (Date, GRN Number, and Verification)'
        : 'कृपया सर्व पेमेंट तपशील भरा (तारीख, GRN क्रमांक, आणि सत्यापन)'}</p>
      <div className={styles.confirmationButtons}>
        <button
          onClick={onCancel}
          className={styles.cancelButton}
        >
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button
          onClick={onConfirm}
          className={styles.saveButton}
        >
          {language === 'en' ? 'Ok' : 'पुष्टी करा'}
        </button>
      </div>
    </div>
  </div>
);